import {
  ARCHIVES_ROUTE_TYPE,
  ARTICLE_ROUTE_TYPE,
  CHANNEL_ROUTE_TYPE,
  CONTRIBUTOR_ROUTE_TYPE,
  PRODUCT_LIST_ROUTE_TYPE,
  SEARCH_ROUTE_TYPE,
  SHOPPING_ROUTE_TYPE,
  STATIC_ROUTE_TYPE,
  EDITION_BASENAME_EN_US,
  EDITION_BASENAME_EN_GB,
  EDITION_BASENAME_DE_DE,
  EDITION_BASENAME_EN_CA,
  EDITION_BASENAME_FR_FR,
  EDITION_BASENAME_EN_AU,
  EDITION_ID_EN_US,
  EDITION_ID_EN_GB,
  EDITION_ID_DE_DE,
  EDITION_ID_EN_CA,
  EDITION_ID_FR_FR,
  EDITION_ID_EN_AU
} from '../constants';
import {
  getPathname,
  isEditionPathname,
  getEditionBasename
} from './paths';

export const DEV_HOSTNAME = 'localhost:4567';

const DEV_PAGE_CONFIG_DEFAULTS = {
  site: 'us',
  edition_id: EDITION_ID_EN_US,
  hostname: DEV_HOSTNAME
};

const PREVIEW_PAGE_PATHNAME_REG_EXP = /^\/blog\/entry/;

const ARCHIVES_CONFIG = {
  type: ARCHIVES_ROUTE_TYPE,
  type_id: 0
};

const US_PATHS = {
  /* Aggregations */

  '/': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 1
  },

  /* Standard channel page: no hero, no CTA bar, no featured stories */
  '/standard-channel': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 2
  },

  /*
   * Gold channel page: hero module, cta bar, and featured stories.
   *
   * (There is also a Silver channel page: hero module, cta bar, but no featured.
   * We do not need a fixture for that type of channel at this time.)
   */
  '/gold-channel': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 5
  },

  /* A channel page with an HTML module */
  '/uncommon-modules-channel': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 3
  },

  /* Watch Homepage */
  '/video': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 6
  },

  /* Full Width Articles */

  '/fw-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10000
  },

  '/fw-article-old-basename': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10000
  },

  '/fw-article-chapters': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10018
  },

  '/fw-article-widgets': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10020
  },

  /*
   * Created with old story editor;
   * does not have width_percentage fields
   * and has blank alignments
   */
  '/fw-article-images': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10003
  },

  /*
   * Created with new story editor;
   * has width_percentage fields
   * and has alignments filled in.
   *
   * Also has asset dimensions artifically inflated
   * to simulate large assets.
   */
  '/fw-article-images-nse': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10011
  },

  '/fw-article-jw': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10004
  },

  '/fw-article-products': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10005
  },

  /* Right Rail Articles */

  '/rr-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10001
  },

  /* Slideshow Articles */

  '/ss-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10002
  },

  '/ss-images-only': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 1000200
  },

  '/ss-article-fw': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10007
  },

  '/ss-slide-types': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10006
  },

  // Has one slide that's a gif
  '/ss-article-gifs': {
    type: 'blog_entry',
    type_id: 10013
  },

  // Has large original assets
  '/ss-article-nse': {
    type: 'blog_entry',
    type_id: 10014
  },

  /* Custom Template Articles */
  // Unused in feature suite
  '/custom-article-chapters': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10019
  },

  // Unused in feature suite
  '/ss-youtube-video-list': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10021
  },

  /* Video Series Articles */

  '/video-series': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10008
  },

  '/video-series-yt': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10009
  },

  '/video-series-fb': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10012
  },

  /* Static Pages */

  '/terms-and-conditions': {
    type: STATIC_ROUTE_TYPE,
    type_id: 18
  },

  '/privacy': {
    type: STATIC_ROUTE_TYPE,
    type_id: 16
  },

  /* Archives */

  '/archives/2016': ARCHIVES_CONFIG,
  '/archives/2016/12': ARCHIVES_CONFIG,
  '/archives/2016/12/14': ARCHIVES_CONFIG,
  '/archives/2016/12/15': ARCHIVES_CONFIG,
  '/archives/2016/12/16': ARCHIVES_CONFIG,
  '/archives/2016/12/23': ARCHIVES_CONFIG,
  '/archives/2016/12/31': ARCHIVES_CONFIG,
  '/archives/landing-page': ARCHIVES_CONFIG,

  /* Search */

  '/search': {
    type: SEARCH_ROUTE_TYPE,
    type_id: 0
  },

  /* Contributors */

  '/author/alyssa-coscarelli': {
    type: CONTRIBUTOR_ROUTE_TYPE,
    type_id: 0
  },

  /* Shopping */

  '/shop/clothing-c918': {
    type: PRODUCT_LIST_ROUTE_TYPE,
    type_id: 918
  },

  '/shop/patchwork-dresses-c10574': {
    type: PRODUCT_LIST_ROUTE_TYPE,
    type_id: 10574
  },

  '/shop/product/uniqlo-jacket-1': {
    type: SHOPPING_ROUTE_TYPE,
    type_id: 1
  },

  '/shop': {
    type: PRODUCT_LIST_ROUTE_TYPE,
    type_id: 916
  },

  '/shop/collections': {
    type: PRODUCT_LIST_ROUTE_TYPE,
    type_id: 987
  },

  /* Special */

  '/bad-react-component': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 4
  },

  '/foundry-404': {
    type: 'foundry_error',
    type_id: 404
  },

  '/foundry-500': {
    type: 'foundry_error',
    type_id: 500
  },

  '/malformed-foundry-response': {
    type: 'malformed_foundry_response',
    type_id: 1
  }
};

/* International Pages */

const UK_PATHS = {
  // Unused in feature suite
  '/': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 1,
    site: 'uk',
    edition_id: EDITION_ID_EN_GB
  },

  '/rr-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10000,
    site: 'uk',
    edition_id: EDITION_ID_EN_GB
  },

  // Unused in feature suite
  '/video-series': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10017,
    site: 'uk',
    edition_id: EDITION_ID_EN_GB
  },

  '/terms-and-conditions': {
    type: STATIC_ROUTE_TYPE,
    type_id: 27,
    site: 'uk',
    edition_id: EDITION_ID_EN_GB
  },

  '/privacy': {
    type: STATIC_ROUTE_TYPE,
    type_id: 26,
    site: 'uk',
    edition_id: EDITION_ID_EN_GB
  },

  '/cookie-policy': {
    type: STATIC_ROUTE_TYPE,
    type_id: 25,
    site: 'uk',
    edition_id: EDITION_ID_EN_GB
  }
};

const DE_PATHS = {
  // Unused in feature suite
  '/': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 1,
    site: 'de',
    edition_id: EDITION_ID_DE_DE
  },

  '/rr-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10000,
    site: 'de',
    edition_id: EDITION_ID_DE_DE
  },

  '/geschaeftsbedingungen': {
    type: STATIC_ROUTE_TYPE,
    type_id: 28,
    site: 'de',
    edition_id: EDITION_ID_DE_DE
  },

  '/datenschutz': {
    type: STATIC_ROUTE_TYPE,
    type_id: 29,
    site: 'de',
    edition_id: EDITION_ID_DE_DE
  },

  '/cookie-richtlinien': {
    type: STATIC_ROUTE_TYPE,
    type_id: 30,
    site: 'de',
    edition_id: EDITION_ID_DE_DE
  }
};

const CA_PATHS = {
  // Unused in feature suite
  '/': {
    type: CHANNEL_ROUTE_TYPE,
    type_id: 1,
    site: 'ca',
    edition_id: EDITION_ID_EN_CA
  },
  '/rr-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10000,
    site: 'ca',
    edition_id: EDITION_ID_EN_CA
  },

  /*
   * Unused in feature suite
   * Contains recommended shows module
   */
  '/video-series': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10001,
    site: 'ca',
    edition_id: EDITION_ID_EN_CA
  },

  '/terms-and-conditions': {
    type: STATIC_ROUTE_TYPE,
    type_id: 0,
    site: 'ca',
    edition_id: EDITION_ID_EN_CA
  },

  '/privacy': {
    type: STATIC_ROUTE_TYPE,
    type_id: 0,
    site: 'ca',
    edition_id: EDITION_ID_EN_CA
  }
};

const FR_PATHS = {
  // Unused in feature suite
  '/rr-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10000,
    site: 'fr',
    edition_id: EDITION_ID_FR_FR
  },

  '/mentions-legales': {
    type: STATIC_ROUTE_TYPE,
    type_id: 0,
    site: 'fr',
    edition_id: EDITION_ID_FR_FR
  },

  '/politique-de-confidentialite': {
    type: STATIC_ROUTE_TYPE,
    type_id: 0,
    site: 'fr',
    edition_id: EDITION_ID_FR_FR
  },

  '/gestion-des-cookies': {
    type: STATIC_ROUTE_TYPE,
    type_id: 0,
    site: 'fr',
    edition_id: EDITION_ID_FR_FR
  }
};

const AU_PATHS = {
  /* Aggregation */

  // Homepage
  '/': {
    type: CHANNEL_ROUTE_TYPE,
    site: 'au',
    type_id: 1,
    edition_id: EDITION_ID_EN_AU
  },

  /* Articles */
  '/rr-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 60000,
    site: 'au',
    edition_id: EDITION_ID_EN_AU
  },

  /* Slideshow Articles */
  '/ss-article': {
    type: ARTICLE_ROUTE_TYPE,
    type_id: 10002,
    site: 'au',
    edition_id: EDITION_ID_EN_AU
  }
};

const getPathsByEdition = (editionBasename) => {
  switch (editionBasename) {
    case EDITION_BASENAME_EN_GB:
      return UK_PATHS;
    case EDITION_BASENAME_DE_DE:
      return DE_PATHS;
    case EDITION_BASENAME_EN_CA:
      return CA_PATHS;
    case EDITION_BASENAME_FR_FR:
      return FR_PATHS;
    case EDITION_BASENAME_EN_AU:
      return AU_PATHS;
    case EDITION_BASENAME_EN_US:
    default:
      return US_PATHS;
  }
};

const getPathsBySite = (site) => {
  switch (site) {
    case 'uk': return UK_PATHS;
    case 'de': return DE_PATHS;
    default: return US_PATHS;
  }
};

const PREVIEW_PAGE_CONFIG = {
  ...DEV_PAGE_CONFIG_DEFAULTS,
  isPreview: true
};

const devPageConfig = (pathname, paths, isEditionPathname) => {
  const config = {
    ...DEV_PAGE_CONFIG_DEFAULTS,
    ...paths[pathname],
    isPreview: false
  };

  /*
   * This is so we can mimic the page config that comes from nginx
   * on production.
   * - If you are on a sites path then `edition_id` is null.
   * - If you are on an editions path then `edition_id` is set.
   * - `site` is set on both sites and editions paths.
   */
  if (!isEditionPathname) {
    config.edition_id = null;
  }

  return config;
};

/*
 * For local development, we currently support paths with sites
 * and their equivalent paths with editions.
 * - In the case of sites, since we cannot use a specific domain
 *   on localhost, we use the query param of `site` to determine
 *   which site we are on, e.g. `localhost:8080/rr-article?site=uk`.
 *   The default site is `us`.
 * - In the case of editions, we are able to incorporate the edition
 *   basename in the path on localhost so we no longer need to use a
 *   query parameter, e.g. `localhost:8080/en-gb/rr-article`
 * - With this logic, `localhost:8080/en-gb/rr-article` should
 *   show the same content as `localhost:8080/rr-article?site=uk`.
 */
export const getDevPaths = (pathname, query) =>
  isEditionPathname(pathname)
    ? getPathsByEdition(getEditionBasename(pathname))
    : getPathsBySite(query.site);

export default (pathname, query = {}) =>
  PREVIEW_PAGE_PATHNAME_REG_EXP.test(pathname)
    ? PREVIEW_PAGE_CONFIG
    : devPageConfig(getPathname(pathname), getDevPaths(pathname, query), isEditionPathname(pathname));
